import {
    SET_OFFERS
  } from '../utils/constants'
  
  const initialState = {
    offers: [],
  }
  
  export default (state = initialState, { type, payload }) => {
    switch (type) {
      case SET_OFFERS:
        return { ...state, offers: payload }
      default:
        return state
    }
  }
  